import axios from 'axios';
import {
  CREATE_PENT_HOUSE_FLOOR,
  GET_HOTEL_KEY_DETAILS,
  HOTEL,
  HOTEL_FLOORS,
} from '../../../service/constants.service';
import {GlobalUtility} from '../../../service/global-utility.service';
import {ALL_HOTEL_FLOORS} from '@/service/constants.service';

const state = {
  hotel: {},
  hotels : [],
  newHotel : {
    name:'',
    email:'',
    address:'',
    status:'',
  },
  allHotelFloors:{},

  sideNavHotelObjecs : [],
  hotelKeys : [],
};

const mutations = {
  set_hotel : (state,param) => {
    state.hotel = param ;
  },

  set_hotels : (state,params) =>{
    state.hotels = params;
  },

  set_new_hotel : (state,params) =>{
    state.hotels.push(params);
    state.newHotel = {
      name:'',
      email:'',
      address:'',
      status,
    };
  },

  set_update_hotel : (state,param) =>{
    const hotel = state.hotels.find( hotel=> hotel.id ===param.id);
    Object.assign(hotel,param);
  },

  set_delete_hotel : (state, param) =>{
    const index = state.hotels.findIndex( hotel => hotel.id = param);
    state.hotels.splice(index,1);
  },


  set_null_hotels : (state) =>{
    state.hotels = [];
  },


  set_side_nav_hotel : (state,param) =>{
    state.sideNavHotelObjecs = param;
  },

  set_allHotelFloors : (state,param) => {
    state.allHotelFloors = param ;
  },


  set_hotel_key : (state,param) =>{
    state.hotelKeys = param;
  },

};

const actions = {
  async getHotels({commit}){
    return await axios.get(HOTEL).then((response)=>{
      commit('set_hotels',response.data);
      // commit('set_side_nav_hotel',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get hotel list');
      return false;
    });
  },

  //hotel
  viewHotel({commit},param){
    return axios.get(`${HOTEL}/${param}`).then((response)=>{
      commit('set_hotel',response.data);
      commit('set_null_room');
      commit('set_null_floor');
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get Hotel Detail');
      return false;
    });
  },

  createHotel({commit},param){
    let parameter = GlobalUtility.deCapitalizeProperties(param);
    return  axios.post(HOTEL,parameter).then((response)=>{
      commit('set_new_hotel',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Create Hotel Record');
      return false;
    });
  },

  async updateHotel({commit},params){
    return await axios.put(`${HOTEL}/${params.id}`,params).then((response)=>{
      commit('set_update_hotel',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Update Hotel Details');
      return false;
    });
  },

  deleteHotel() {
    //todo
  },

  //floors
   getHotelFloors({commit},param){
    return  axios.get(`${HOTEL_FLOORS}/${param}`).then((response)=>{
      commit('set_floors',response.data.floors);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get Hotel Floors')
      return false;
    });
  },

  getHotelKeyDetails({commit},){
    return axios.get(GET_HOTEL_KEY_DETAILS).then((response)=>{
      commit('set_hotel_key',response.data);
      commit('set_side_nav_hotel',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get Hotel Key Details.');
      return false;
    });
  },


  setNullHotels({commit}){
    commit('set_null_hotels');
  },

  async getAllHotelFloors({commit}){
    return await axios.get(ALL_HOTEL_FLOORS).then((response)=>{
      commit('set_allHotelFloors',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get hotel list');
      return false;
    });
  },

  createPentHouse({commit},params){
    return axios.post(`${CREATE_PENT_HOUSE_FLOOR}/${params}`).then((response)=>{
      commit('set_new_floor',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Create Pent-House');
      return false;
    })
  }
};

const getters = {
  hotels : state => GlobalUtility.deCapitalizeProperties(state.hotels),
  hotel: state => state.hotel,
  newHotel : state => GlobalUtility.deCapitalizeProperties(state.newHotel),
  sideNavHotelObjecs : state => state.sideNavHotelObjecs,
  allHotelFloors: state => state.allHotelFloors,
  hotelKeys : state => state.hotelKeys,
};

export default {state,actions,mutations,getters};
